module.exports = __webpack_public_path__ + "static/media/video.fd0b2065.svg";